import { combineReducers } from 'redux'
import { layoutReducer } from './layout.js'
import { receiptReducer } from './receipt.js'
import { generalReducer } from './general.js'
import { loginReducer } from './login.js'
import { objectManagementReducer } from '../objectmanagement/reducers/objectmanagement.js'
import { modalReducer } from '../modal/reducers/modal.js'
import { ticketReducer } from '../ticket/reducers/ticketReducer.js'
import { barcodeReducer } from './barcode.js'

const rootReducer = combineReducers({
  generalState: generalReducer,
  layoutState: layoutReducer,
  receiptState: receiptReducer,
  loginState: loginReducer,
  objectManagementState: objectManagementReducer,
  modalState: modalReducer,
  ticket: ticketReducer,
  barcodeState: barcodeReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// src/reducers/index.js